import React from 'react'
import PropTypes from 'prop-types'

import { InlineButton } from '../../../index'
import { useTranslation } from '../../../../utils/providers'

function FilterResetButton({ resetAllFilters }) {
  const { t } = useTranslation()
  return (
    <InlineButton className="px-2 text-underline" onClick={resetAllFilters}>
      {t('FILTER_RESET_ALL')}
    </InlineButton>
  )
}

FilterResetButton.propTypes = {
  resetAllFilters: PropTypes.func.isRequired,
}

export default FilterResetButton
